import {FilterOptionProps} from '../../MyTeamsContent.types';

export const buildFIBCItems = (
  onSelect: (id: string) => void,
): FilterOptionProps[] => {
  const baseItems = [
    {text: 'Any', id: 'any', defaultVal: true},
    {text: 'Yes', id: 'yes', defaultVal: false},
    {text: 'No', id: 'no', defaultVal: false},
  ];

  return baseItems.map(item => ({
    ...item,
    selected: item.defaultVal,
    onPress: () => onSelect(item.id),
  }));
};
